var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeliveryScheduleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.33333C0 0.596953 0.596953 0 1.33333 0H22.6667C23.4031 0 24 0.596953 24 1.33333V5.33333H0V1.33333Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.33203H6V14.6654H0V7.33203Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 16.668V22.668C0 23.4044 0.596953 24.0013 1.33333 24.0013H6V16.668H0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 16.668V24.0013H16V16.668H8Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18 16.668V24.0013H22.6667C23.4031 24.0013 24 23.4044 24 22.668V16.668H18Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24 14.6654V7.33203H18V14.6654H24Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16 14.6654H8V7.33203H16V14.6654Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveryScheduleIcon);
export default __webpack_public_path__ + "static/media/DeliveryScheduleIcon.1906a4f4088265c7f5fb32abccb8c901.svg";
export { ForwardRef as ReactComponent };